"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { cn } from "@local/utils/src/cn";
// import { getShippingThreshold } from "@local/cart/src/shipping"
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { roboto } from "../../../utils/fonts";
import type { ContentIconsSingleIconProps } from "./ContentIconsSingleIcon";
export const ContentIconsSingleIconJustified = t0 => {
  const $ = _c(20);
  const {
    icon,
    className,
    market
  } = t0;
  let currencySymbol;
  bb0: switch (market) {
    case "eu":
      {
        currencySymbol = "\u20AC";
        break bb0;
      }
    case "ch":
      {
        currencySymbol = "CHF";
        break bb0;
      }
    case "au":
      {
        currencySymbol = "AU$";
        break bb0;
      }
    case "nz":
      {
        currencySymbol = "NZ$";
        break bb0;
      }
    case "ca":
      {
        currencySymbol = "CA$";
        break bb0;
      }
    case "gb":
      {
        currencySymbol = "\xA3";
        break bb0;
      }
    default:
      {
        currencySymbol = "$";
      }
  }
  let t1;
  if ($[0] !== currencySymbol || $[1] !== icon.heading) {
    t1 = icon.heading.replace("%%CURRENCY%%", `${currencySymbol}\u2060`).replace("%%SHIPPING%%", Math.round(0.1).toString());
    $[0] = currencySymbol;
    $[1] = icon.heading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const heading = t1;
  let t2;
  if ($[3] !== currencySymbol || $[4] !== icon.text) {
    t2 = icon.text.replace("%%CURRENCY%%", `${currencySymbol}\u2060`).replace("%%SHIPPING%%", Math.round(0.1).toString());
    $[3] = currencySymbol;
    $[4] = icon.text;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const text = t2;
  let t3;
  if ($[6] !== className) {
    t3 = cn("flex min-w-[95%] flex-col items-start justify-start align-middle", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== icon.heading || $[9] !== icon.image?.url) {
    t4 = icon.image?.url ? <div className="flex w-4/5 items-start" aria-hidden="true"><Image src={getCdnUrl({
        src: icon.image?.url || "",
        width: 40
      })} alt={icon.heading} role="presentation" width={40} height={40} className="mb-2 max-w-[120px]" /></div> : null;
    $[8] = icon.heading;
    $[9] = icon.image?.url;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== heading) {
    t5 = <h3 className="text-h5 leading-heading my-2 font-semibold uppercase">{heading}</h3>;
    $[11] = heading;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== text) {
    t6 = <p className={`${roboto.className} text-base leading-5 font-normal`}>{text}</p>;
    $[13] = text;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};